// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3NZ6M","containerItemsCenter":"Skeleton_containerItemsCenter__OsvBF"};